import {
  ReportGmailerrorredOutlined,
  ChevronLeft,
  AppsOutlined,
  LocalMallOutlined,
  LogoutOutlined,
  TrendingUpOutlined,
  SmsOutlined,
  StorefrontOutlined,
  SettingsOutlined,
} from "@mui/icons-material";
import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
import Divider from "@mui/material/Divider";
import Drawer from "@mui/material/Drawer";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import { styled } from "@mui/material/styles";
import MenuItem from "./menuItem";
import { useLocation } from "react-router-dom";

export const drawerWidth = 280;

const navigation = [
  {
    name: "Dashboard",
    href: "/",
    icon: AppsOutlined,
  },
  {
    name: "Transaction",
    href: "/transactions",
    icon: LocalMallOutlined,
  },
  {
    name: "Loans",
    href: "/loans",
    icon: LocalMallOutlined,
  },
  {
    name: "Farm Track",
    href: "/farmtracks",
    icon: TrendingUpOutlined,
  },
  {
    name: "Chat",
    href: "/chats",
    icon: SmsOutlined,
  },
  {
    name: "Store",
    href: "/store",
    icon: StorefrontOutlined,
  },
  {
    name: "Settings",
    href: "/settings",
    icon: SettingsOutlined,
  },
];

const logout = {
  name: "Logout",
  href: "/logout",
  icon: LogoutOutlined,
};

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: "flex-end",
}));

interface SideNavProps {
  open: boolean;
  handleDrawerOpenClose: () => void;
}

export default function SideNav({ open, handleDrawerOpenClose }: SideNavProps) {
  const location = useLocation();
  console.log(location);

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": {
            width: drawerWidth,
            boxSizing: "border-box",
          },
          display: "flex",
          flexDirection: "column",
        }}
        variant="persistent"
        anchor="left"
        open={open}
      >
        <>
          <DrawerHeader sx={{ paddingY: 6, alignSelf: "center" }}>
            {<img src="/assets/logo.png" alt="Logo" width={150} />}
          </DrawerHeader>
          <Divider />
          <List>
            {navigation.map((menuItem, key) => (
              <MenuItem
                menu={menuItem}
                key={key}
                isActive={location.pathname === menuItem.href}
              />
            ))}
          </List>
        </>

        <Divider sx={{ paddingTop: 15 }} />
        <MenuItem menu={logout} />
      </Drawer>
    </Box>
  );
}
